import { DeviceVendor } from '@customTypes/common';

export const preventDefaultEvents = (event: React.MouseEvent) => {
  event.stopPropagation();
  event.preventDefault();
};

export const getDeviceVendor = (vendor: string): string => {
  switch (vendor) {
    case DeviceVendor.GREE:
      return 'Gree';
    case DeviceVendor.TUYA:
    default:
      return 'Tuya';
  }
};

export const stripHtmlTags = (html: string): string => {
  if (!html) return '';

  // Create a temporary div element to parse HTML
  const temp = document.createElement('div');
  temp.innerHTML = html;

  // Get text content (automatically handles HTML entities)
  return temp.textContent || temp.innerText || '';
};
